import React from 'react';
import { withTheme } from 'styled-components';
import { Box } from '@rsos/components/capstone/base';
import { DARK_THEME } from '@rsos/theme/constants';
import { RapidSOSLogoCompact, FullLogo } from '../../common/logo/RapidSOSLogo';

const PremiumLogo = ({
  theme,
  compact,
  showUniteLogo = false,
  height = 52,
}) => {
  const { name: themeName = '' } = theme.colors;
  const isDarkMode = themeName === DARK_THEME;

  if (compact) {
    return <RapidSOSLogoCompact />;
  }

  return (
    <Box horizontal flow={7} align="center">
      <FullLogo
        showUniteLogo={showUniteLogo}
        height={height}
        color={isDarkMode ? 'background' : 'primaryText'}
      />
    </Box>
  );
};
export default withTheme(PremiumLogo);
